import { useEffect, useState } from 'preact/hooks';

/**
 * Viewport tier driving the sidebar's responsive behaviour (prototype breakpoints):
 * - `wide`   > 1100px  → full sidebar (or rail if the user manually collapses it)
 * - `mid`    761–1100  → rail (icon-only), forced
 * - `narrow` ≤ 760px   → off-canvas drawer
 */
export type ViewportTier = 'wide' | 'mid' | 'narrow';

function tierFor(width: number): ViewportTier {
  if (width <= 760) return 'narrow';
  if (width <= 1100) return 'mid';
  return 'wide';
}

export function useViewportTier(): ViewportTier {
  const [tier, setTier] = useState<ViewportTier>(() =>
    tierFor(typeof window === 'undefined' ? 1440 : window.innerWidth),
  );
  useEffect(() => {
    const onResize = () => setTier(tierFor(window.innerWidth));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return tier;
}
